<template>
  <div class="page-content">
    <el-breadcrumb class="breadcrumb-box" separator="/">
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage">资料信息</span></el-breadcrumb-item>
      <el-breadcrumb-item v-if="isBindMobile">修改绑定</el-breadcrumb-item>
      <el-breadcrumb-item v-if="isUpdatePassword">修改密码</el-breadcrumb-item>
    </el-breadcrumb>

    <el-row v-if="!isBindMobile && !isUpdatePassword" :gutter="20">
      <el-col :span="7">
        <div style="height:650px;flex-direction:column;border-radius:16px;" class="g-content-box g-vertical-center">
          <!-- <p>{{ userInfo.depart_name }}</p> -->
          <el-image style="width: 100px;margin-top: 64px;" :src="smallLogo"></el-image>
          <span class="g-block" style="font-size: 20px;font-weight:bold;padding: 40px 0 60px;">{{ userInfo.realname }}</span>

          <div class="myinfo-detail-item" style="padding-top: 20px;">
          <el-row style="border-bottom: 1px solid #EBEEF5;padding-bottom: 8px;">
            <el-col :span="24">
              <i class="el-icon-user myinfo-icon"></i>
              <span class="g-margin-left" style="font-weight: bold;">
                用户名:
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px;">
              <span style="margin-left: 30px;">
                {{ userInfo.username }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px;">
              <span @click="onUpdatePassword" class="myinfo-btn">修改密码 <i class="el-icon-arrow-right"></i></span>
            </el-col>
          </el-row>
        </div>

        <div class="myinfo-detail-item" style="padding-top: 20px;" v-if="logintype != 'KEFU' && logintype != 'ADMIN'">
          <el-row style="border-bottom: 1px solid #EBEEF5;padding-bottom: 8px;">
            <el-col :span="24">
              <img class="myinfo-icon myinfo-img" :src="phone" alt="">
              <span class="g-margin-left" style="font-weight: bold;">
                绑定手机:
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px;">
              <span style="margin-left: 30px;">
                {{ userInfo.mobile ? userInfo.mobile : "-" }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px;">
              <span @click="onBindMobile" class="myinfo-btn">{{ hasMobile ? '修改绑定' : '立即绑定' }} <i class="el-icon-arrow-right"></i></span>
            </el-col>
          </el-row>
        </div>

        <div class="myinfo-detail-item" style="padding-top: 20px;" v-if="logintype != 'KEFU' && logintype != 'ADMIN'">
          <el-row style="border-bottom: 1px solid #EBEEF5;padding-bottom: 8px;">
            <el-col :span="24">
              <img class="myinfo-icon myinfo-img" :src="wechat" alt="">
              <span class="g-margin-left" style="font-weight: bold;">
                绑定微信:
              </span>
            </el-col>
            <el-col :span="18" style="padding-top: 8px;">
              <span style="margin-left: 30px;">
                {{ userInfo.unionid ? userInfo.nickname : '未绑定' }}
              </span>
            </el-col>
            <el-col :span="6" style="padding-top: 8px;">
              <span @click="onBindWechat" class="myinfo-btn">{{ userInfo.unionid ? '解除绑定' : '立即绑定' }} <i class="el-icon-arrow-right"></i></span>
            </el-col>
          </el-row>
        </div>
        </div>
      </el-col>
      <el-col :span="17" id="newShopinfoCard">
        <el-card class="g-content-box shopinfo-card2">
          <div>
            <div style="font-size: 16px;font-weight: 600;">服务客户信息</div>
          </div>
          <el-table
            :data="serviceList"
            height="630"
          >
            <el-table-column
              type="index"
              label="序号"
            >
            </el-table-column>
            <el-table-column
              prop="companyname"
              label="公司名称"
            >
            </el-table-column>
            <el-table-column
              prop="company_memoname"
              label="公司备注名称"
            >
            </el-table-column>
          </el-table>
          <!-- <Pagination
            v-if="serviceList.length"
            class="pagination"
            :total="serviceList.length"
            v-model="pagination"
            @onChange='load'
          /> -->
        </el-card>

      </el-col>
    </el-row>
      <!--微信绑定页 -->
      <el-dialog
        title="微信绑定"
        :visible.sync="showWechatDialog"
        width="15%"
      >
        <el-image
          style="width: 100%; height: 100%"
          :src="wechatUrl"
        >
        </el-image>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" class="g-confirm-btn" @click="showWechatDialog = false">确定</el-button>
          <el-button size="small" class="g-cancel-btn" @click="showWechatDialog = false">取消</el-button>
        </span>
      </el-dialog>
    <!--绑定手机页 -->
    <div v-if="isBindMobile">
      <div class="g-content-box" v-if="hasMobile">
        <el-steps :active="currentMobileStep">
          <el-step title="验证身份" description="需要使用当前绑定手机验证身份"></el-step>
          <el-step title="绑定新手机" description="请填写你需要绑定的新手机号"></el-step>
          <el-step title="绑定成功" description="成功绑定新手机号码"></el-step>
        </el-steps>
      </div>


      <div v-if="hasMobile && currentMobileStep === 0" class="myinfo-mobile-box">
        <el-form :model="mobile" ref="mobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item label="手机号">
            <span>{{ userInfo.mobile }}</span>
          </el-form-item>
          <el-form-item class="myinfo-code-item" label="验证码">
            <el-input size="small" v-model="mobile.code" class="myinfo-code-input" placeholder="输入验证码"></el-input>
            <el-button :disabled="Boolean(codeNumber)" class="g-margin-left" @click="getMobileCode(1)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onConfirmCode(1)">确定</el-button>
            <el-button size="small" class="g-cancel-ben" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="(hasMobile && currentMobileStep === 1) || (!hasMobile && currentMobileStep === 0)" class="myinfo-mobile-box">
        <el-form :model="newmobile" ref="newmobile" label-width="80px" class="myinfo-mobile-form">
          <el-form-item label="新手机号">
            <el-input size="small"  v-enter-number v-model="newmobile.mobile" class="myinfo-code-input" placeholder="输入新手机号"></el-input>
          </el-form-item>
          <el-form-item class="myinfo-code-item" label="验证码">
            <el-input size="small" v-model="newmobile.code" class="myinfo-code-input" placeholder="输入验证码"></el-input>
            <el-button size="small" :disabled="Boolean(codeNumber)" class="g-margin-left" @click="getMobileCode(2)">
              <span v-if="!codeNumber">获取验证码</span>
              <span v-else>{{ codeNumber }}s后重新发送</span>
            </el-button>

            <p v-if="codeNumber">
              <i class="el-icon-success" style="color: #3FB838"></i>
              <span class="g-margin-left">
                验证码已发送到你的手机，5分钟内输入有效
              </span>
              <span class="g-block" style="padding-left: 24px">
                验证码等同于密码，打死也不能告诉别人!
              </span>
            </p>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onConfirmCode(2)">提交</el-button>
            <el-button size="small" class="g-cancel-btn" @click="isBindMobile = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="currentMobileStep === 2" class="myinfo-mobile-box myinfo-bind-success">
        <i class="el-icon-success" style="color: #3FB838;font-size: 40px;display: block"></i>
        <p>绑定成功</p>
        <p>新登录方式:使用新手机号和密码登录</p>
        <el-button class="g-confirm-btn" @click="isBindMobile = false;load()">完成</el-button>
      </div>


      </div>
       <!-- 修改密码页 -->
      <div v-if="isUpdatePassword">
      <div class="myinfo-mobile-box">
        <el-form :model="password" :rules="passwordRules" ref="password" label-width="100px" class="myinfo-mobile-form">
          <el-form-item label="当前密码" prop="current">
            <el-input size="small" type="password" v-model="password.current" placeholder="输入当前密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new">
            <el-popover
              placement="right"
              trigger="focus"
              width="150"
              >
              <div >
                <span>
                  强度: &nbsp; {{ passwordPercent === 33 ? '弱' : passwordPercent === 100 ? '强' : '中'  }}
                </span>
                <el-progress
                  :show-text="false"
                  :percentage="passwordPercent"
                  :color="customColors">
                </el-progress>
                <span class="g-block">
                  请至少输入6个字符，请不要使用容易被猜到的密码
                </span>
              </div>
              <div slot="reference">
                <el-input size="small" @input="onPasswordChange" type="password" v-model="password.new" placeholder="输入新密码"></el-input>
              </div>
            </el-popover>
          </el-form-item>
          <el-form-item label="确认新密码" prop="checknew">
            <el-input size="small" type="password" v-model="password.checknew" placeholder="再次输入新密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="g-confirm-btn" @click="onSubmitPassword">确定</el-button>
            <el-button size="small" class="g-cancel-btn" @click="isUpdatePassword = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import smallLogo from '@/assets/img/smallLogo.png'
import VDistpicker from 'v-distpicker';
import { mapState, mapGetters, mapActions } from 'vuex';
import Wechat from '@/assets/img/other/wechat.png'
import Calendar from '@/assets/img/other/calendar.png'
import Phone from '@/assets/img/other/phone.png'
import Pagination from 'components/pagination/pagination'
import aes from '@/libs/aes'
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
export default {
  name: 'DataInfomation',

  components:{
    wxBindingComponent
    // VDistpicker,
    // Pagination
  },

  data () {

    let validatePass = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入新密码'));
			} else if (value.toString().length < 6 || value.toString().length > 16) {
				callback(new Error('密码长度为6 - 16个字符'))
			} else {
				callback();
			}
    };
		let validatePass2 = (rule, value, callback) => {
	      if (value === '') {
	      callback(new Error('请再次输入密码'));
	      } else if (value !== this.password.new) {
	      callback(new Error('两次输入密码不一致!'));
	      } else {
	      callback();
	      }
	  };
    return {
      smallLogo: smallLogo,
      wechatUrl: '',
      pagination: {
        size: 10,
        current: 1
      },
      serviceList: [],
      customFields: {},
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      passwordPercent: 33,
      customColors: [
        {color: '#f56c6c', percentage: 34},
        {color: '#e6a23c', percentage: 67},
        {color: '#5cb87a', percentage: 99},
      ],
      passwordStatus: 'low',
      password: {},
      companyRules: {
        address: [
            { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        takepeople: [
            { required: true, message: '请输入对接人', trigger: 'blur' }
        ],
        contact: [
            { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
      },
      passwordRules: {
        new: [
            { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checknew: [
            { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        current: [
            { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
      },
      showWechatDialog: false,
      isUpdatePassword: false,
      timer: null,
      newmobile: {},
      currentMobileStep: 0,
      codeNumber: 0,
      mobile: {},
      form: {},
      showEditDialog: false,
      wechat: Wechat,
      calendar: Calendar,
      phone: Phone,
      isBindMobile: false,
      logintype: '',
    }
  },

  methods: {
    onSubmitCompany() {
      console.log(this.form);

      this.$refs['company'].validate((valid) => {
        if(valid) {
          let data = {
            contact: this.form.contact,
            province: this.form.province,
            city: this.form.city,
            strict: this.form.strict,
            address: this.form.address,
            take_people: this.form.takepeople,
          }

          this.reqEditDealer(data).then(res => {
            if(res.status === '10000') {
              this.reqDealerInfo();
              this.showEditDialog = false;
            }
          })
        }

      })
    },
    onBindWechat() {
      let data = {
        userid: this.userInfo.id,
        usertype: 'c',
        domainname: window.location.host.substring(0, window.location.host.indexOf("."))
      }
      if(this.userInfo.unionid) {
        this.reqUnbindWx(data).then((res) => {
          if(res.status === '10000') {
            this.load();
          }
        })
      }else {
        this.$refs.childWxBinding.getbmcwx('c',this.userInfo.id)
      }
    },
    onEditCompany() {
      this.form = {};
      this.showEditDialog = true;
      this.form = Object.assign({}, this.form, this.dealerInfo);
    },
    ...mapActions([
      'reqMoblieCode',
      'reqMyInfomation',
      'reqBindMobile',
      'reqUpdatePassword',
      'reqUnbindWx',
      'reqDealerInfo',
      'reqServiceUser',
      'reqServiceList',
      'reqValidateSMS',
    ]),
    onUpdatePassword() {
      this.passwordPercent = 33;
      this.isUpdatePassword = true;
    },
    onSubmitPassword() {
      this.$refs['password'].validate((valid) => {
        if (valid) {
          let data = {
            password: aes.encrypt(this.password.new, 'hcmabcdefghijklm'),
            oldPassword: aes.encrypt(this.password.current, 'hcmabcdefghijklm'),
            username: this.userInfo.username
          }
          this.reqUpdatePassword(data).then((res) => {
            if(res.status === '10000') {
              this.$message({
                message: '修改成功!',
                type: 'success'
              })
            }
            if(res.status === '400') {
              this.$message({
                message: `${res.message}`,
                type: 'error'
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onPasswordChange(value) {
      let numberReg = /^[0-9]*$/;
      let bigReg = /^[A-Z]+$/;
      let smallReg = /^[a-z]+$/;
      let specialReg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/;
      let number = false;
      let small = false;
      let big = false;
      let special = false;
      let strArr = value.split("");
      if(strArr.length < 6) {
        this.passwordPercent = 33;
      }else if(6 < strArr.length < 16){
        for(let i of strArr) {
          if(numberReg.test(i)) {
            number = true;
          }
          if(bigReg.test(i)) {
            big = true;
          }
          if(smallReg.test(i)) {
            small = true;
          }
          if(specialReg.test(i)) {
            special = true;
          }

        }
        let res = [
          number, small, big, special
        ]
        let trueRes = res.filter(item => {
          return item === true;
        })
        if(trueRes.length === 1) {
          this.passwordPercent = 33;
        }else if(2 === trueRes.length || trueRes.length === 3) {
          this.passwordPercent = 66;
        }else if(trueRes.length === 4) {
          this.passwordPercent = 100;
        }
      }
    },
    getMobileCode(step) {
      let data;
      if(step === 1) {
        data = {
          mobile: this.userInfo.mobile,
          codeType: 'HCM_BIND',
          usertype: localStorage.getItem('usertype')
        }
      }else {
        data = {
          mobile: this.newmobile.mobile,
          codeType: 'HCM_BIND',
          usertype: localStorage.getItem('usertype')
        }
      }


      this.reqMoblieCode(data).then(() => {
        this.codeNumber = 60;
        this.handleTimer();
      })

    },
    handleTimer() {
      this.timer = setTimeout(() => {
          this.codeNumber--;
          if(!this.codeNumber) {
            clearTimeout(this.timer);
            return
          }
          this.handleTimer();
        }, 1000);
    },
    reinitTimer() {
      this.codeNumber = 0;
      clearTimeout(this.timer);
    },
    onConfirmCode(step) {
      this.reinitTimer();
      if(step === 2) {
        let data = {
          mobile: this.newmobile.mobile,
          code: this.newmobile.code
        }
        this.reqValidateSMS(data).then((res) => {
          if(res) {
            this.reqBindMobile({
              mobile: this.newmobile.mobile
            }).then(() => {
              this.currentMobileStep = 2;
            })
          }
        })
      }else {
        let data = {
          mobile: this.userInfo.mobile,
          code: this.mobile.code
        }
        this.reqValidateSMS(data).then((res) => {
          if(res) {
            this.currentMobileStep += 1;
          }
        })
      }
    },
    onBindMobile() {
      this.reinitTimer();
      this.mobile = {};
      this.newmobile = {};
      this.currentMobileStep = 0;
      this.isBindMobile = true;
    },
    onChangePage() {
      this.isBindMobile = false;
      this.isUpdatePassword = false;
      this.load();
    },
    load() {
      this.reqServiceUser();
      this.reqMyInfomation();
    },
  },

  computed: {
    hasMobile() {
      return this.userInfo.mobile ? true : false;
    },
    ...mapState({
      userInfo: state => state.myInfomation.userInfo,
    })
  },

  created() {

    this.load();
    let params ={
      usertype: localStorage.getItem('usertype')
    }
    this.logintype = JSON.parse(localStorage.getItem('userData')).logintype
    this.reqServiceList().then(res => {
      console.log(typeof res);
      this.serviceList = res.data;
    })
  },

  mounted() {},
}
</script>


<style lang='scss'>
@import "style/activityDeclaration.scss";
@import "style/myInfomation.scss";
.breadcrumb-box .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: bold;
}

#newShopinfoCard {
  .el-card__body {
    padding: 0px;
  }
}

.pagination {
  margin-top: 20px;
  padding-right: 20px;
  text-align: right;
}

.breadcrumb-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
  padding-left: 20px;
}
</style>
